import React from "react";
import { Col, Container, Image, Row } from "react-bootstrap";
import "./Skills.css";
import html from "../../../images/HTML.png";
import css from "../../../images/CSS.png";
import bootstrap from "../../../images/bootstrap.png";
import tailwind from "../../../images/Tailwind.png";
import daisyui from "../../../images/daisyui.png";
import reactBootstrap from "../../../images/bootstrap.png";
import javascript from "../../../images/JavaScript.png";
import react from "../../../images/React.png";
import reactRouter from "../../../images/ReactRouterDom.png";
import firebase from "../../../images/Firebase.png";
import node from "../../../images/nodejs.png";
import express from "../../../images/Express.png";
import mongodb from "../../../images/MongoDB.png";
import jwt from "../../../images/JWT.png";
import python from "../../../images/python.png";
import c from "../../../images/c.png";
import typescript from "../../../images/typescript.png";
import redux from "../../../images/redux.png";
import next from "../../../images/nextjs.png";
import postgresql from "../../../images/postgresql.png";
import mysql from "../../../images/mysql.png";

const skillsData = [
  { src: html, name: "HTML" },
  { src: css, name: "CSS" },
  { src: bootstrap, name: "Bootstrap" },
  { src: tailwind, name: "TailwindCSS" },
  { src: reactBootstrap, name: "React Bootstrap" },
  { src: javascript, name: "JavaScript" },
  { src: react, name: "React" },
  { src: reactRouter, name: "React Router" },
  { src: firebase, name: "Firebase" },
  { src: node, name: "Node.js" },
  { src: express, name: "Express.js" },
  { src: mongodb, name: "MongoDB" },
  { src: jwt, name: "JWT" },
  { src: daisyui, name: "Daisy UI" },
  { src: python, name: "Python" },
  { src: c, name: "C" },
  { src: typescript, name: "TypeScript" },
  { src: redux, name: "Redux" },
  { src: next, name: "NextJS" },
  { src: postgresql, name: "PostgreSQL" },
  { src: mysql, name: "MySQL" },
];

const Skills = () => {
  return (
    <div>
      <Container>
        <div>
          <h1 style={{ color: "#ccd6f6" }} className="skill-title">
            What I do 👇
          </h1>
          <h4 className="my-5">
            CRAZY MERN STACK DEVELOPER WHO WANTS TO EXPLORE EVERY TECH STACK
          </h4>
        </div>
        <Row>
          {skillsData.map((skill, index) => (
            <Col key={index} md={4} lg={2} xs={4}>
              <div className="skill-col">
                <div className="d-flex justify-content-center">
                  <Image style={{ height: "120px" }} src={skill.src} />
                </div>
                <p className="text-center pt-2">{skill.name}</p>
              </div>
            </Col>
          ))}
        </Row>
      </Container>
    </div>
  );
};

export default Skills;
